import { render } from "./TeamSection.vue?vue&type=template&id=53b7deac&scoped=true"
import script from "./TeamSection.vue?vue&type=script&lang=js"
export * from "./TeamSection.vue?vue&type=script&lang=js"

import "./TeamSection.vue?vue&type=style&index=0&id=53b7deac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b7deac"]])

export default __exports__